import styled from 'styled-components';

import { colors, fontWeights } from 'theme/theme';

export const ViewJobPageSidebarResultsHolder = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  /* Add padding to avoid cutting off box-shadow */
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 5px;
`;

export const ViewJobPageSidebarResultsHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 8px;
`;

export const ViewJobPageSidebarResultsHeaderTitle = styled.h4`
  font-size: 16px;
  color: ${colors.mediumContentGrey};
  font-weight: ${fontWeights.normal};
  margin: 0;
`;
